import React from 'react';
import { Route } from 'react-router-dom';
import SurveysForm from './surveysForm';

export default (
  <Route path="/homepage/survey/:surveyId/:actionId" component={SurveysForm} />
);
